import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CalendarDays, Clock } from 'lucide-react';
import { plannerAPI } from '../../services/api';

const WeeklyPlanView = () => {
  const [plan, setPlan] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    plannerAPI.getWeek()
      .then((data) => active && setPlan(data))
      .catch((loadError) => active && setError(loadError.message || 'Weekly planner unavailable'));
    return () => {
      active = false;
    };
  }, []);

  const days = Array.isArray(plan?.daily_targets) ? plan.daily_targets : [];

  return (
    <motion.section
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white/5 border border-white/10 backdrop-blur-lg rounded-lg p-5 md:p-6"
    >
      <div className="flex items-center justify-between gap-4 mb-5">
        <h2 className="text-xl font-bold text-white flex items-center">
          <CalendarDays className="w-6 h-6 text-pink-300 mr-3" />
          Weekly Plan
        </h2>
        {plan ? <span className="text-sm text-purple-200">{Math.round(plan.completion_percentage || 0)}% complete</span> : null}
      </div>
      {error ? (
        <div className="text-sm text-rose-200 bg-rose-500/10 border border-rose-500/30 rounded-lg p-3">{error}</div>
      ) : days.length === 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-3">
          {[1, 2, 3, 4, 5, 6, 7].map((item) => <div key={item} className="h-36 rounded-lg bg-white/5 border border-white/10 animate-pulse" />)}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-3">
          {days.map((day) => (
            <div key={day.date} className="bg-white/5 border border-white/10 rounded-lg p-3 min-h-[150px]">
              <p className="text-white font-semibold">{day.day}</p>
              <p className="text-xs text-purple-200 mt-1 line-clamp-1">{day.focus}</p>
              <div className="flex items-center text-xs text-gray-400 mt-2">
                <Clock className="w-3.5 h-3.5 mr-1" />
                {day.estimated_minutes}m
              </div>
              <div className="space-y-2 mt-3">
                {(day.tasks || []).slice(0, 3).map((task) => (
                  <div key={task.title} className="text-xs text-gray-200 bg-slate-900/30 rounded-md px-2 py-1.5 line-clamp-2">
                    {task.title}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </motion.section>
  );
};

export default WeeklyPlanView;
